export const STRING_ONLY_ATTRIBUTE_CODES = ['category_id'];
export const SWATCH_SMALL = 'small';
export const SWATCH_LARGE = 'large';
